import React from 'react';


function DlgRelGraficoResTunoDia() {
  return (
    <>
      <iframe width="100%" height="100%" style={{ border:'none' }} src="https://bi.unidatanet.com.br/VLI/#/pages/itemGraficoTurnoResumoPSDia?url="></iframe>
    </>
  );
}


export default DlgRelGraficoResTunoDia;
